import { init } from '@nosto/preact'

import serpComponent from './serp'
import categoryComponent from './category'
import autocompleteComponent from './autocomplete'
import historyComponent from './history'
import { defaultConfig } from './config'
import { unbindOriginalSearch } from "./helpers"

import './styles/index.css';

unbindOriginalSearch('form.Search__Form');

const catName = document.querySelector('.nosto_category > .category_string')
    ? document.querySelector('.nosto_category > .category_string')
    : document.querySelector('.nosto_category')

/* ---------- for shoppable novel app, HK store only ---------- */
const novelShopSection = document.getElementById('shopify-section-novel-shoppable-video-plp');
const header = document.getElementById('shopify-section-header');
if(
    (window.Shopify?.country === 'HK' || window.Shopify?.store === 'dvf-hongkong.myshopify.com') &&
    novelShopSection && header
) {
    novelShopSection.remove();
    header.insertAdjacentElement('afterend', novelShopSection);
}
/* ------------------------------------------------------------ */

init({
    ...window.nostoTemplatesConfig,
    serpComponent,
    autocompleteComponent,
    categoryComponent,
    serpPath: "/search",
    inputCssSelector: "input.Search__Input",
    contentCssSelector: 'section.collection',
    serpPathRedirect: true,
    formCssSelector: 'form.search-form',
    serpUrlMapping: {
        query: 'q'
    },
    categoryCssSelector: "section.collection.collection-products",
    isCategoryPage() {
        return location.href.includes('collections')
    },
    categoryQuery() {
        const catId = document.querySelector(".nosto_category span[class='id']");
        return {
            name: 'serp',
            products: {
                // categoryId: catId?.textContent,
                // categoryPath: catName?.textContent,
                categoryId: this.categoryId(),
                categoryPath: this.categoryPath(),
                size: defaultConfig.serpSize,
                from: 0
            }
        }
    },
    serpQuery: {
        products: {
            fields: [
                'productId', 'url', 'name', 'imageUrl', 'alternateImageUrls', 'thumbUrl', 'description', 'brand', 'availability', 'price', 'priceText', 'listPrice', "categories", 'customFields.key', 'customFields.value', 'tags1', 'skus.id', 'skus.name', 'skus.availability', 'skus.customFields.key', 'skus.customFields.value'
            ],
            facets: ['*'],
            size: defaultConfig.serpSize,
            from: 0,
        },
    },
    autocompleteQuery: {
        products: {
            fields: [
                'productId', 'url', 'name', 'imageUrl', 'alternateImageUrls', 'thumbUrl', 'brand', 'availability', 'price', 'priceText', 'availability', 'listPrice', 'ratingValue', "categories", 'customFields.key', 'customFields.value', 'tags1', 'skus.id', 
            ],
            size: defaultConfig.autocompleteSize,
        },
    },
}).then(() => {
    const input = document.querySelector("input.Search__Input");
    input.addEventListener("keydown", function (e) {
        if (e.keyCode == 13) {
            document.querySelector(".search-popdown__close__button")?.click()
        }
    })
    
    const openSearch = document.querySelector(".Header__Link--search");
    if(openSearch) {
        openSearch.addEventListener("click", function () {
            setTimeout(() => {
                input.focus()
            }, 250)
        })
    };

})